import { z } from 'zod';

export const meetPersonSchema = z.object({
  mobile: z.string(),
  name: z.string().nullable(),
});

export type MeetPerson = z.infer<typeof meetPersonSchema>;
